import { useEffect, useRef } from 'react'
import { Grid } from '@mui/material'
import { useFormikContext } from 'formik'
import { t } from 'i18next'
import { AutoCompleteField, InputField } from 'src/components/shared/ui/form/fields'
import { useTipoMensajeContext } from 'src/contexts/TipoMensajeContext'
import { FormField } from 'src/enums/Form'
import { useGetColegios } from 'src/hooks/fetch/useCatalogoGeneralFilters'
import { Provincia, TipoRepresentacion } from 'src/interfaces/Catalog'
import { RepresentanteProcesal } from 'src/interfaces/EscritosLegales'
import { tipoRepresentacionProfesional } from '../RepresentanteProcesal/types'

type Props = {
  tipoRepresentacion?: TipoRepresentacion | null
  provincia?: Provincia | null
  requiredNIF?: boolean
  entidadLabel?: string
}

export default function ProfesionalForm(props: Props): JSX.Element {
  const { tipoRepresentacion, provincia, requiredNIF = false, entidadLabel = 'Entidad' } = props
  const colegioData = useGetColegios(FormField.COLEGIO, [provincia, tipoRepresentacion])
  const didMount = useRef(false)

  const { isMonitorio } = useTipoMensajeContext()
  const { values, setFieldValue } = useFormikContext<RepresentanteProcesal | any>()

  useEffect(() => {
    if (didMount.current) {
      setFieldValue('colegio', null)
    }
    didMount.current = true
    // eslint-disable-next-line
  }, [values.tipoTraslado, values.comunidadTrasladoCopias, values.provinciaTrasladoCopias])
  if (tipoRepresentacion) {
    if (tipoRepresentacionProfesional(tipoRepresentacion)) {
      return (
        <>
          <Grid item xs={12} sm={6}>
            <AutoCompleteField
              id={FormField.COLEGIO}
              label={entidadLabel}
              items={colegioData}
              itemName="descripcion"
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputField
              id={FormField.CODIGO_COLEGIADO}
              label={t('form.field.codigo_colegiado')}
              required
              maxLength={10}
            />
          </Grid>
          {!isMonitorio && (
            <>
              <Grid item xs={12} sm={6}>
                <InputField
                  id={FormField.INTERVINIENTE_REPRESENTANTE_PROCESAL_NIF}
                  label={t('form.field.representante_procesal_nif')}
                  required={requiredNIF}
                  maxLength={12}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputField
                  id={FormField.INTERVINIENTE_NOMBRE}
                  label={t('form.field.nombre')}
                  maxLength={50}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputField
                  id={FormField.INTERVINIENTE_PRIMER_APELLIDO}
                  label={t('form.field.primer_apellido')}
                  maxLength={100}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputField
                  id={FormField.INTERVINIENTE_SEGUNDO_APELLIDO}
                  label={t('form.field.segundo_apellido')}
                  maxLength={50}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputField
                  id={FormField.INTERVINIENTE_REPRESENTANTE_PROCESAL_EMAIL}
                  label={t('form.field.email')}
                  maxLength={100}
                />
              </Grid>
            </>
          )}
        </>
      )
    }
  }
  return <></>
}
